export interface PttAckSyncState {
  pendingCaptureOnAck: boolean;
  expectedTraceId: string | null;
}

export interface PttAckTransition {
  nextState: PttAckSyncState;
  shouldStartCapture: boolean;
}

export interface PttStartAckState {
  pendingUnmute: boolean;
  expectedTraceId: string | null;
}

export interface PttStartAckTransition {
  nextState: PttStartAckState;
  shouldUnmute: boolean;
}

export function pttTraceMatches(expectedTraceId: string | null, incomingTraceId?: string): boolean {
  return !expectedTraceId || expectedTraceId === incomingTraceId;
}

export function transitionPttAck(
  state: PttAckSyncState,
  incomingTraceId?: string,
): PttAckTransition {
  if (!state.pendingCaptureOnAck || !pttTraceMatches(state.expectedTraceId, incomingTraceId)) {
    return { nextState: state, shouldStartCapture: false };
  }

  return {
    nextState: {
      pendingCaptureOnAck: false,
      expectedTraceId: null,
    },
    shouldStartCapture: true,
  };
}

export function transitionPttTimeout(state: PttAckSyncState): PttAckTransition {
  if (!state.pendingCaptureOnAck) {
    return { nextState: state, shouldStartCapture: false };
  }

  return {
    nextState: {
      pendingCaptureOnAck: false,
      expectedTraceId: null,
    },
    shouldStartCapture: true,
  };
}

export function transitionPttStartAck(
  state: PttStartAckState,
  ack: { traceId?: string; accepted?: boolean },
): PttStartAckTransition {
  if (!state.pendingUnmute || !pttTraceMatches(state.expectedTraceId, ack.traceId)) {
    return { nextState: state, shouldUnmute: false };
  }

  return {
    nextState: {
      pendingUnmute: false,
      expectedTraceId: null,
    },
    shouldUnmute: ack.accepted !== false,
  };
}

export function transitionPttStartTimeout(state: PttStartAckState): PttStartAckTransition {
  if (!state.pendingUnmute) {
    return { nextState: state, shouldUnmute: false };
  }

  return {
    nextState: {
      pendingUnmute: false,
      expectedTraceId: null,
    },
    shouldUnmute: false,
  };
}
